export const WELLNESS_TYPE_MAPPING = {
    'GT03-MASS': 'Massagen',
    'GT03-SAUN': 'Sauna',
    'GT03-SOLA': 'Solarium',
    'GT03-SPAA': 'Spaa',
    'ST03-STBA': 'Dampfbad',
}